// @flow
import React from 'react';
import injectSheet from 'react-jss';

type Props = {
  classes: Object,
  color_theme: 'DARK' | 'LIGHT'
}

function FutureSightSeparator({ classes }: Props) {
  return (
    <div className={classes.separator} />
  );
}

const styles = {
  separator: {
    width: '75%',
    height: '1px',
    backgroundColor: (props) => {
      const colors = {
        DARK: 'white',
        LIGHT: 'rgb(234,234,234)'
      };

      return colors[props.color_theme] || 'rgb(234,234,234)';
    },
    margin: '36px',
    '@media(max-width: 960px)': {
      width: 'auto'
    }
  }
};

export default injectSheet(styles)(FutureSightSeparator);
